'use strict';
window.renderProductDescription = function(options){
  const {root,section,searchTools,searchInput,emptyMessage,title}=options;
  root.innerHTML=options.html||'';
  root.querySelectorAll('script,style,link,object,embed,iframe,form').forEach(node=>node.remove());
  root.querySelectorAll('*').forEach(node=>{
    [...node.attributes].forEach(attribute=>{
      if(attribute.name==='style'||/^on/i.test(attribute.name)||(/^(href|src)$/i.test(attribute.name)&&/^\s*javascript:/i.test(attribute.value)))node.removeAttribute(attribute.name);
    });
  });
  const emptyValue=value=>!value.trim()||/^(?:n\/?a|n\.a\.|not specified|not provided|unknown|pending|tbd|[-—])$/i.test(value.trim());
  const isGroup=row=>row.cells.length===1&&row.cells[0].colSpan>1;
  const isColumnHeading=row=>row.cells.length>1&&[...row.cells].every(cell=>cell.tagName==='TH'&&cell.scope!=='row');
  const entries=[],tables=[];
  root.querySelectorAll('table').forEach(table=>{
    const rows=[...table.rows];
    rows.forEach(row=>{
      const cells=[...row.cells];
      if(isGroup(row)||isColumnHeading(row))return;
      const values=cells.length>1?cells.slice(1):cells;
      if(!values.length||values.every(cell=>emptyValue(cell.textContent)))row.remove();
    });
    let group=null,hasRows=false;
    const currentEntries=[];
    for(const row of [...table.rows]){
      if(isGroup(row)){
        if(group&&!hasRows)group.remove();group=row;hasRows=false;
      }else if(!isColumnHeading(row)){
        hasRows=true;currentEntries.push({row,group});
      }
    }
    if(group&&!hasRows)group.remove();
    if(!currentEntries.length){table.remove();return}
    const wrapper=document.createElement('div');wrapper.className='description-table-scroll';table.before(wrapper);wrapper.append(table);
    if([...table.rows].some(row=>row.cells.length>2))table.classList.add('description-wide-table');
    tables.push({table,wrapper,entries:currentEntries});entries.push(...currentEntries);
  });
  const textCopy=root.cloneNode(true);
  textCopy.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(node=>node.remove());
  const text=textCopy.textContent.replace(/\s+/g,' ').trim();
  const onlyName=text.toLowerCase()===String(options.productTitle||'').toLowerCase();
  section.hidden=(!text||onlyName)&&!root.querySelector('img,video');
  section.classList.toggle('compact-description',entries.length>0&&entries.length<=6);
  section.dataset.specRows=entries.length;
  section.dataset.descriptionMode=entries.length?'table':'text';
  if(title)title.textContent=entries.length?options.labels.specifications:options.labels.description;
  searchTools.hidden=entries.length<12;emptyMessage.hidden=true;
  searchInput.oninput=()=>{
    const term=searchInput.value.trim().toLowerCase();let total=0;
    tables.forEach(item=>{
      let tableMatches=0;const groupMatches=new Map();
      item.entries.forEach(entry=>{
        const hit=!term||entry.row.textContent.toLowerCase().includes(term)||(entry.group&&entry.group.textContent.toLowerCase().includes(term));
        entry.row.hidden=!hit;
        if(entry.group)groupMatches.set(entry.group,(groupMatches.get(entry.group)||false)||Boolean(hit));
        if(hit){tableMatches++;total++}
      });
      groupMatches.forEach((hasMatch,heading)=>heading.hidden=!hasMatch);
      item.wrapper.hidden=!tableMatches;
    });
    emptyMessage.hidden=!term||total>0;
  };
  return {rows:entries.length,tables:tables.length,hidden:section.hidden};
};
